import { Layout } from 'antd';
import appointmentActions from 'features/appointment/services/actions';
import React, { Suspense, useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import ModalAnybody from './components/ModalAnybody';
import AppointmentsPageStyled from './styles';
import AppointmentCalendarV2 from './components/Calendar/v2';
import ButtonViewFullStaff from './components/ButtonViewFullStaff';
import useTabletApp from 'hooks/useTabletApp';

type IAppointmentsPageProps = {
  public?: boolean;
};
const AppointmentsPage: React.FC<IAppointmentsPageProps> = ({ public: isPublic }) => {
  if (isPublic)
    useTabletApp(true);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(appointmentActions.initData());
  }, []);

  return (
    <AppointmentsPageStyled>
      <Layout>
        <AppointmentCalendarV2 />
      </Layout>
      <ModalAnybody />
      <ButtonViewFullStaff />
    </AppointmentsPageStyled>
  );
};

export default AppointmentsPage;
